import React, { Component } from "react";
import { Popover, Form, Button, Icon, Table, Modal, Input, message } from "antd";
import { getCheckedTypeList, addCheckType, editCheckType, deleteCheckType } from '@/request/api'
import './components.scss'
import { requestErrorLog } from '@/common/util'

const { confirm } = Modal;
const { TextArea} = Input;
class SettingDepartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableList: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
      className :'',
      textareaText :'',
      departmentColumns: [
        {
          title: "类型编码",
          dataIndex: "CLASS_CODE",
          key: "CLASS_CODE",
          width: 170,
        },
        {
          title: "类型名称",
          dataIndex: "CLASS_NAME",
          key: "CLASS_NAME",
          width: 170,
        },
        {
          title: "备注",
          dataIndex: "REMARKS",
          key: "REMARKS",
          width: 300,
          render: (text) => {
            return (
              <Popover
                placement="topLeft"
                overlayStyle={{ width: "100px" }}
                content={<span style={{ color: "#333" }}>{text}</span>}
              >
                <span>{text}</span>
              </Popover>
            );
          },
        },
      ],
    }
  }

  componentDidMount() {
    this.getTableList()
  }

  getTableList = () => {
    let params = {
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      NAME : this.state.className
    }
    getCheckedTypeList(params).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          tableList: res.Result.dataList,
          rowCount: res.Result.rowCount,
          rowData:null,
        })
      }else{
        requestErrorLog('', '系统设置-检查类型-获取检查类型列表报错', 0, true)
      }
    })
  }
  
  handleCheckTypeAdd = () => {// 新增
    this.props.form.resetFields();
    this.setState({
      isModalVisible: true,
      modalTitle: 'add',
      rowData: {
        CLASS_CODE: "",
        CLASS_NAME: ""
      }
    })
  }

  handleCheckTypeEdit = () => { // 修改
    const { rowData } = this.state
    this.props.form.resetFields();
    if (rowData && rowData.CLASS_CODE) {
      this.setState({
        editModalVisible: true,
        modalTitle: 'edit',
      })
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handleCheckTypeDelete = () => { // 删除
    const { rowData } = this.state
    if (rowData) {
      confirm({
        title: '删除操作',
        content: '确认删除该类型吗？',
        onOk: () => {
          deleteCheckType(rowData).then(res=>{
            if(res && res.Status === 1){
              message.success('删除成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-检查类型-删除检查类型报错', 0, true)
              message.error('删除失败')
            }
          })

        },
      });
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handleOk = () => {
    const { isModalVisible, editModalVisible, rowData } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (isModalVisible === true) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
          let params = {
            CLASS_CODE : values.CLASS_CODE,
            CLASS_NAME : values.CLASS_NAME,
            REMARKS : values.REMARKS,
          }
          addCheckType(userInfo.HOSPITAL_CODE,params).then(res=>{
            console.log(res)
            if(res && res.Status === 1){
              if(res.Result === '2'){
                message.error('编码或名称不能重复')
                return;
              }
              message.success('添加成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-检查类型-添加检查类型报错', 0, true)
              message.error('添加失败')
            }
            this.setState({
              isModalVisible : false
            })
          })
        }
        if (editModalVisible === true) {
          let params = {
            EXAM_CLASS_UID : rowData.EXAM_CLASS_UID,
            CLASS_CODE : values.CLASS_CODE,
            CLASS_NAME : values.CLASS_NAME,
            REMARKS : values.REMARKS,
          }
          editCheckType(params).then(res=>{
            if(res && res.Status === 1){
              if(res.Result === '2'){
                message.error('编码或名称不能重复')
                return;
              }
              message.success('编辑成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-检查类型-编辑检查类型报错', 0, true)
              message.error('编辑失败')
            }
            this.setState({
              editModalVisible :false,
            })
          })
        }
      }
    })
  }

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record
        });
      },
    };
  }

  setRowClassName = (record) => {
    return record === this.state.rowData ? 'clickRowStyl' : '';
  }

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      editModalVisible: false
    })
  }

  classNameChange = e => {
    this.setState({
      className: e.target.value,
    })
  }

  handleCheckTypeList = () => {
    this.setState({
      pageNo: 1,
      pageSize: 10
    }, () => {
      this.getTableList()
    })
  }
  changeFocus = e => {
    if (e.keyCode === 13) {
      this.handleCheckTypeList();
    }
  }
  changePageFn = (pageNo) => {
    this.setState({
      pageNo
    }, () => {
      this.getTableList()
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, editModalVisible, modalTitle, departmentColumns, tableList, rowData } = this.state;

    return (
      <div>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handleCheckTypeAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={this.handleCheckTypeEdit}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handleCheckTypeDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>
        <Form layout="inline" className="searchBox">
          <Form.Item label="类型名称">
            <Input allowClear value={this.state.className} onChange={this.classNameChange} onKeyUp={this.changeFocus} />
          </Form.Item>
          <Button onClick={this.handleCheckTypeList}>查询</Button>
        </Form>
        <Table
          columns={departmentColumns}
          dataSource={tableList}
          rowKey={(record) => record.EXAM_CLASS_UID}
          bordered
          pagination={{
            total: this.state.pageNo,
            current: this.state.pageNo,
            onChange: this.changePageFn
          }}
          onRow={this.onClickRow}
          rowClassName={this.setRowClassName}
        />
        {isModalVisible || editModalVisible ?
          <Modal
            title={
              <div className="patient_title">
                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                <span>{modalTitle === "add" ? "添加检查类型" : "编辑检查类型"}</span>
              </div>
            }
            visible={isModalVisible || editModalVisible}
            maskClosable={false}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <Form layout="inline" className="settingFormBox">
              <Form.Item label="类型编码" className="settingHospitalAddr">
                {getFieldDecorator('CLASS_CODE', { initialValue: rowData && rowData.CLASS_CODE ? rowData.CLASS_CODE : '',rules: [{ required: true, message: '请输入类型编码' }] })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="类型名称" className="settingHospitalAddr">
                {getFieldDecorator('CLASS_NAME', { initialValue: rowData && rowData.CLASS_NAME ? rowData.CLASS_NAME : '',rules: [{ required: true, message: '请输入类型名称' }] })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注" className="settingHospitalAddr">
                {getFieldDecorator('REMARKS', { initialValue: rowData && rowData.REMARKS ? rowData.REMARKS : ''})(<TextArea rows={5} />)}
              </Form.Item>
            </Form>
          </Modal> : null
        }

      </div>
    );
  }
}

export default (Form.create({})(SettingDepartment));
